const colors = {
  white: '#fff',
  whiteRGBA: (alpha = 0.5) => `rgba(255, 255, 255, ${alpha})`,
  black: '#000',
  transparent: 'transparent',
  background: '#F5F5F5',
  backgroundHover: '#F0F0F0',
  accent: '#90205D',
  accentHover: '#811C4E',
  primary: '#293E57',
  primaryRGBA: (alpha = 0.7) => `rgba(49, 56, 85, ${alpha})`,
  primaryHover: '#263343',
  secondary: '#EE4352',
  drawer: '#F5F5F5',
  secondaryRGBA: (alpha = 0.15) => `rgba(236, 66, 82, ${alpha})`,
  disabled: '#CCCCCC',
  gray: '#CECECE',
  grayHover: '#DBDBDB',
  green: '#70BF42',
  darkGrey: '#3D3D3D',
  lessBlack: '#314155',
  grayish: '#5C5C5C',
  moreGray: '#C9C9C9'
}

export default colors
